<template>
    <div class="header">
        <div class="content fixed">
            <div class="left">
                <img src="../assets/logo.png" alt="">
            </div>
            <div class="right">
                <ul>
                    <li 
                    @mouseenter="toggle(value)"
                    @click="change(value)" 
                    v-for='(value,index) in list' 
                    :key="index"
                    :class="{'active':value==clickValue}">{{value}}</li>
                </ul>
                <!-- <div class="down_menu" v-if="downMenu" @mouseleave="closeBox()">
                    <div class="box" v-for="(value,index) in categoryList" :key="index">
                        <p>{{value.category_name}}</p>
                        <template  v-if="value.sub_list.length!=0">
                            <div class="list_wrap">
                                <div class="list" @click="selectProduct(item)" v-for="(item,index) in value.sub_list" :key="index">{{item.sub_name}}</div>
                            </div>
                            <div class="more" v-if="value.sub_list.length>2">查看更多</div>
                        </template>
                    </div>
                </div> -->
                <!-- <div class="about_us" v-if="isAbout" @mouseleave="closeBox()">
                    <div class="right">
                        <ol>
                            <li v-for="(value,index) in aboutList" :key="index">{{value}}</li>
                        </ol>
                    </div>
                    <img src="../assets/about_header.png" alt="">
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import {getCategoryListApi} from "@/request/api"
export default {
    name:'commonheader',
    watch:{
        '$route':function(newUrl){
            if(newUrl.name=='aboutDetailNews'){
                this.clickValue='关于我们'
            }else{
                this.clickValue=newUrl.name
            }
        }
    },
    created(){
        let name=window.location.pathname.split('/')
        switch(name[name.length-1]){
            case '/' : this.clickValue = '首页';
            break;
            case '' : this.clickValue = '首页';
            break;
            case 'project' : this.clickValue = '产品中心';
            break;
            case 'solve' : this.clickValue = '解决方案';
            break;
            case 'service' : this.clickValue = '服务支持';
            break;
            case 'exampleCase' : this.clickValue = '客户案例';
            break;
            case 'about' : this.clickValue = '关于我们';
            break;
            case 'aboutIntroduction' : this.clickValue = '关于我们';
            break;
            case 'aboutHonour' : this.clickValue = '关于我们';
            break;
            case 'aboutTalent' : this.clickValue = '关于我们';
            break;
            case 'aboutNews' : this.clickValue = '关于我们';
            break;
            case 'aboutOperative' : this.clickValue = '关于我们';
            break;
            case 'aboutUs' : this.clickValue = '关于我们';
            break;
            case 'news1' : this.clickValue = '关于我们';
            break;
            case 'news2' : this.clickValue = '关于我们';
            break;
            case 'news3' : this.clickValue = '关于我们';
            break;
            default:
                this.clickValue = '关于我们';
        }
        //this.init()
    },
    data(){
        return{
            list:['首页','产品中心','解决方案','服务支持','客户案例','关于我们'],
            clickValue:'首页',
            downMenu:false,
            categoryList:[{title:"工业机器人",children:[{name:'工业机器人装调与考评系统'},{name:"工业机器人装调与考评系统"},{name:"工业机器人装调与考评系统"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]},{title:"教学平台",children:[{name:'立方学院'},{name:"智能制造"}]}],
            aboutList:['公司介绍','校企合作','荣誉资质','人才计划','联系我们','公司新闻'],
            isAbout:false,
            enterName:'',
            searchInfo:{
                is_more:0,
                cur_index:3,
                category_id:''
            }
        }
    },
    
    methods:{
        init(){
            this.getToken(getCategoryListApi,this.searchInfo,res=>{
                this.categoryList=res.data
            })
        },
        change(data){
            this.clickValue=data
            let path=''
            switch(data){
                case '首页' : path = '/'
                break;
                case '产品中心' : path = '/project'
                break;
                case '解决方案' : path = '/solve'
                break;
                case '服务支持' : path = '/service'
                break;
                case '客户案例' : path = '/exampleCase'
                break;
                case '关于我们' : path = '/aboutIntroduction'
                break;
            }
            this.$router.push({path:path})
        },
        toggle(data){
            this.enterName=data
            if(data=='产品中心'||data=='解决方案'){
                this.downMenu=true
            }else{
                this.downMenu=false
            }
            this.isAbout=data=='关于我们'?true:false
        },
        closeBox(){
            if(this.downMenu){this.downMenu=false}
            if(this.isAbout){this.isAbout=false}
        },
        selectProduct(item){
            this.$router.push({path:'/project',query:{category_id:item.category_id,sub_id:item.sub_id}})
        }
    }
}
</script>
<style lang="stylus" scoped>
.header
    background:#f2f2f2
    .content
        display:flex;
        height:80px;
        justify-content:space-between
        .left
            img 
                height:53px;
                margin-top:14px;
        ul
            display:flex;
            margin:0;
            li
                font-size:16px;
                line-height:78px;
                padding:0 30px;
                color:#565956;
                cursor:pointer;
                border-bottom:2px solid #f2f2f2
                &:hover
                    color:#19a0ff;
                    // border-bottom:2px solid #19a0ff;
                    // line-height:78px;
            li.active
                color:#19a0ff
                line-height:78px;
                border-bottom:2px solid #19a0ff;
            li.hoverBtn
                color:#19a0ff
                line-height:78px;
                border-bottom:2px solid #19a0ff;
        .down_menu
            position:absolute;
            top:80px;
            background:#fff;
            display:flex;
            flex-wrap:wrap;
            z-index:999;
            width:1200px;
            left:50%;
            transform:translateX(-50%);
            padding:30px;
            font-size:16px;
            .box
                padding:0 30px;
                &:not(:last-child)
                    border-right:1px solid #e6e6e6;
                p
                    font-weight:bold;
                .list_wrap
                    height:90px;
                    .list
                        line-height:30px;
                        cursor pointer
                        &:hover
                            color:#19a0ff
                .more
                    border:1px solid #999;
                    border-radius:10px;
                    padding:1px 8px;
                    font-size:14px;
                    color:#999;
                    margin-top:20px;
                    display:inline-block;
                    cursor pointer
        .about_us
            width:548px;
            height:220px;
            background:#fff;
            display:flex;
            justify-content:space-between;
            position:absolute;
            right:calc(50% - 600px)
            padding:50px 30px;
            ol
                list-style:none;
                overflow:hidden;
                border-right:1px solid #e3e3e3;
                margin-right:30px;
                li
                    width:50%;
                    float:left;
                    line-height:30px;
                    &:hover
                        color:#19a0ff
                        cursor:pointer;
                

            
                   


</style>